import React, { memo } from 'react';
import classNames from 'classnames';
import { format } from 'date-fns';

import './BetHeader.scss';

interface BetHeaderProps{
  sport: string,
  tournamentName: string,
  eventName: string,
  fixtureCode: number,
  betCode: number,
  venue: string
  date?: Date,
  showTournament?: boolean
}

function BetHeader({ sport, tournamentName, eventName, venue, date=null, showTournament=true }: BetHeaderProps) {

  return (
    <div className="sport-header">
      {
        sport !== 'lotto' && <div className={
          classNames({
            'sport-icon': true,
            [`sport-icon-${ sport.toLowerCase().split(' ').join('') }`]: true,
            'sport-header__icon': true
          })
        }
        />
      }
      {
        sport === 'lotto' && <div className="sport-header__icon sport-header__icon--lotto" />
      }
      { showTournament && <h3 className="sport-header__tournament-name">{ tournamentName }</h3> }
      <h4 className="sport-header__competitors">{ sport !== 'lotto' ? eventName :  `${ format(date, 'HH:mm') } Draw` }</h4>
      <h5 className="sport-header__infos"> {
        venue ?
          `${ format(date, 'dd/MM') } | ${ format(date, 'HH:mm') } | ${ venue }` :
          `${ format(date, 'dd/MM') } | ${ format(date, 'HH:mm') }`
      }
      </h5>
    </div>
  );

}

export default memo(BetHeader);
